/**
 * Class for team sections.
 *
 * @class      Team (name)
 */
export class Team
{
	/**
	 * Adds necessary event listeners.
	 */
	static addListeners()
	{
		// Wait for DOMContentLoaded
		$( document ).ready(
			() =>
			{
				// Get a list of team sections
				let teamSections = document.querySelectorAll( '.team' );

				// Loop sections
				teamSections.forEach(
					teamSection =>
					{
						// Instantiate jQuery objects
						let $teamSection  = $( teamSection );
						let $selectFilter = $teamSection.find( '.team-select-filter' );
						let $gridItems    = $teamSection.find( '.team-grid' );

						// Instantiate an object to hhold our arguments
						let isotopeArgs =
						{
							itemSelector: '.team-grid-item',
						};

						// Paranoid sanity check so it doesn't break in case we ever remove the filter in a template
						if ( $selectFilter.length )
						{
							// Get the value of the select filter in this section specifically
							isotopeArgs.filter = '.' + $selectFilter.val();
						}

						// Boot up the grid
						let $grid = $gridItems.isotope( isotopeArgs );

						// Listen for filter changes
						$selectFilter.on(
							'change',
							( evt ) =>
							{
								$grid.isotope(
									{
										filter: '.' + $( evt.target ).val(),
									}
								);
							}
						);

						// Await a full load
						$( window ).load(
							() =>
							{
								// Re-calculate layout. This adds handling for a rare bug where initial layout would break.
								$grid.isotope( 'layout' );
							}
						);
					}
				);


				$( '.team__item .overlay' ).on(
					'click',
					( evt ) =>
					{
						evt.stopPropagation();

						if ( ! $( evt.target ).siblings( '.team__contact-info' ).hasClass( 'open' ) )
						{
							$( evt.target ).siblings( '.team__contact-info' ).addClass( 'open' );
						}
					}
				);


				$( '.team__bg-info-close-btn' ).on(
					'click',
					( evt ) =>
					{
						evt.stopPropagation();

						if ( $( evt.target ).parent( '.team__contact-info' ).hasClass( 'open' ) )
						{
							$( evt.target ).parent( '.team__contact-info' ).removeClass( 'open' );
						}
					}
				);
			}
		);
	}
}



// WEBPACK FOOTER //
// ../wp-content/plugins/wisesite-team/assets/js/modules/team/team.js